export type AssetSearchState = {
  terms: string[];
  draft: string;
};

const LINE_BREAK = /[\r\n]+/;

function normalizeTerm(value: string) {
  return value.trim();
}

/** Split a newline-delimited serial list. Blank lines and repeated serials are dropped. */
export function termsFromLineList(value: string, existing: string[] = []) {
  const seen = new Set(existing.map((term) => term.toLowerCase()));
  const terms = [...existing];

  value.split(LINE_BREAK).forEach((part) => {
    const term = normalizeTerm(part);
    if (!term) return;

    const key = term.toLowerCase();
    if (seen.has(key)) return;

    seen.add(key);
    terms.push(term);
  });

  return terms;
}

/**
 * A query with no newline stays as draft text, so a model like MacBookPro14,1 is one search.
 * Newlines mean each line is its own serial.
 */
export function parseAssetSearchQuery(query: string): AssetSearchState {
  if (!LINE_BREAK.test(query)) return { terms: [], draft: query };

  return { terms: termsFromLineList(query), draft: "" };
}

export function formatAssetSearch(terms: string[], draft: string) {
  return [...terms, normalizeTerm(draft)].filter(Boolean).join("\n");
}

export function commitDraft(terms: string[], draft: string) {
  return termsFromLineList(draft, terms);
}

/** Replace the selected draft with a pasted line list. Text outside the selection stays on its own lines. */
export function insertPastedLines(draft: string, text: string, start: number, end: number) {
  return [draft.slice(0, start), text, draft.slice(end)].filter((part) => normalizeTerm(part)).join("\n");
}
